// Shared horizontal-rhythm wrapper for Breaches page sections. Server component.

export function BreachesSection({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative">
      <div className="relative z-10 px-5 sm:px-8">
        <div className="max-w-310 mx-auto w-full">{children}</div>
      </div>
    </div>
  );
}
